var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9004 13.8001C14.9004 13.9001 14.7004 14.0001 14.5004 14.0001H1.50039C1.30039 14.0001 1.20039 13.9001 1.10039 13.8001C1.00039 13.6001 1.00039 13.5001 1.10039 13.3001L7.60039 1.30015C7.70039 1.00015 8.00039 0.900146 8.20039 1.10015C8.30039 1.10015 8.40039 1.20015 8.40039 1.30015L14.9004 13.3001C15.0004 13.5001 15.0004 13.6001 14.9004 13.8001ZM8.52461 5.50012H7.52461V9.00012H8.52461V5.50012ZM7.22461 11.1001C7.22461 10.6001 7.62461 10.3001 8.02461 10.3001C8.42461 10.3001 8.82461 10.6001 8.82461 11.1001C8.82461 11.6001 8.42461 11.9001 8.02461 11.9001C7.52461 11.9001 7.22461 11.6001 7.22461 11.1001ZM13.6004 13.0001H2.30039L8.00039 2.50015L13.6004 13.0001Z",
    fill: "#F43F5E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.4cd0865da9d7bd09e10946f3d495e171.svg";